import classNames from "classnames";
import { Container } from "components/layout/Container";
import { ArticleCard } from "components/pages/blog/article/ArticleCard";

import s from "./ArticlesList.module.scss";
import cs from "@/styles/modules/card.module.scss";
import { BlogPagination, BlogPaginationProps } from "../BlogPagination";
import { ArticleListItemData } from "@/types/strapi/article";
import cn from "classnames";
import { CTABanner } from "@/components/pages/blog/CTABanner";
import { useCallback } from "react";

type ArticlesListProps = {
  heading?: string;
  list: ArticleListItemData[];
  pagination: BlogPaginationProps;
  className?: string;
  showSubcategory?: boolean;
  urlPrefix?: string;
  includeTaxonomyInURL?: boolean;
};

export const ArticlesList = ({
  heading,
  list,
  pagination,
  className,
  showSubcategory,
  urlPrefix,
  includeTaxonomyInURL = true,
}: ArticlesListProps) => {
  const firstBatchOfArticles = list.slice(0, 6);

  const secondBatchOfArticles = list.slice(6);
  const renderArticle = useCallback(
    (item: ArticleListItemData) => (
      <ArticleCard
        key={item.slug}
        className={s.item}
        {...item}
        showSubcategory={showSubcategory}
        urlPrefix={urlPrefix}
        includeTaxonomyInURL={includeTaxonomyInURL}
      />
    ),
    [showSubcategory, urlPrefix, includeTaxonomyInURL]
  );

  return (
    <div className={classNames(s.wrapper, className)}>
      <Container>
        {heading && <h2 className={cn(cs.h2, s.heading)}>{heading}</h2>}
        <div className={s.list}>
          {firstBatchOfArticles.map(renderArticle)}
          <CTABanner className={s.ctaBanner} />
          {secondBatchOfArticles.map(renderArticle)}
        </div>
        {pagination && pagination.pageCount > 1 && <BlogPagination {...pagination} />}
      </Container>
    </div>
  );
};
